import * as React from "react";

const SvgComponent = ({ bgcolor, border, color }) => (
  <svg width={31} height={30} fill="none">
    <rect
      x={1.301}
      y={0.5}
      width={29}
      height={29}
      rx={5.5}
      fill={bgcolor}
      stroke={border}
    />
    <path
      d="M22.726 7.41c-.305-.053-1.26.08-3.391-.336-1.701-.332-3.231-.898-3.231-.898s-1.003.529-2.983.898c-2.464.458-3.64.336-3.64.336s-.67 8.494.604 11.297c.978 2.151 5.127 3.877 6.018 4.234.892-.357 5.041-2.083 6.02-4.234 1.274-2.804.603-11.297.603-11.297Zm-1.872 10.472c-.772 1.698-4.047 3.06-4.75 3.342-.704-.282-3.978-1.644-4.75-3.342-1.007-2.212-.477-8.916-.477-8.916l5.226-1.003 5.228 1.003s.53 6.704-.477 8.917Z"
      fill={color}
    />
    <path
      d="M16.342 8.613s-.536 11.6 0 11.892c.63-.253 3.561-1.471 4.252-2.991.9-1.98.427-7.981.427-7.981l-4.68-.92Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;
